import { useMemo } from 'react';
import { Divider, Form, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import cloneDeep from 'lodash/cloneDeep';
import { PreWorkUIConfig } from '../../../shared/CategoryStepUIConfig';
import { usePreWorkInterviewWizard } from './usePreWorkInterviewWizard';
import { usePreWorkInterviewFormHandling } from './usePreWorkInterviewFormHandling';
import { CategoryStep } from './CategoryStep';
import { PreWorkQuestionId } from '../../../shared/Constants';
import { PreWorkInterviewStepType } from './PreWorkInterviewStepType';
import { PreworkCompletionStatus } from '../../../shared/PreWorkServiceTypes';

const { Text } = Typography;

const UiConfig = PreWorkUIConfig;

export const PreWorkInterviewStep = () => {
	const { t } = useTranslation();
	const clonedUiConfig = useMemo(() => {
		return cloneDeep(UiConfig);
	}, []);

	const {
		preWorkMentorCategoryAnswers,
		setPreWorkMentorCategoryAnswers,
		preWorkData,
	} = usePreWorkInterviewWizard();

	const { form, updateFieldValue } = usePreWorkInterviewFormHandling(
		preWorkMentorCategoryAnswers,
		setPreWorkMentorCategoryAnswers,
		preWorkData
	);

	const values = Form.useWatch<PreWorkInterviewStepType>([], form);

	const updatedUiConfig = {
		...clonedUiConfig,
		questionsToAskInPreworkMentorInterview: {
			...clonedUiConfig.questionsToAskInPreworkMentorInterview,
			mandatoryQuestionsToAsk:
				clonedUiConfig.questionsToAskInPreworkMentorInterview.mandatoryQuestionsToAsk.map(
					(question) => {
						const isMentorConcernsQuestion =
							question.questionId ===
							PreWorkQuestionId.MENTOR_CONCERNS_QUESTION;

						const selectedOption =
							values?.[PreWorkQuestionId.MENTOR_CONCERNS_QUESTION]
								?.selectedOption;

						if (isMentorConcernsQuestion && selectedOption === 1) {
							return {
								...question,
								hideComments: false,
								commentsRequired: true,
							};
						} else if (isMentorConcernsQuestion && selectedOption !== 1) {
							return {
								...question,
								hideComments: true,
								commentsRequired: false,
							};
						}

						return question;
					}
				),
		},
	};

	return (
		<>
			<div className="flex flex-col">
				<Text className="font-sans font-semibold text-lg text-secondary-black text-center mt-3">
					{t('preworkConfirmationQuestions')}
				</Text>
			</div>
			<Divider className="border border-solid border-gray-200" />
			<CategoryStep
				uiConfig={updatedUiConfig}
				mandatoryQuestionsAndAnswersForm={form}
				answers={preWorkData.userAnswers}
				mentorAnswers={preWorkData.mentorAnswers}
				updateFieldValue={updateFieldValue}
				isPreworkApproved={
					preWorkData.mentorcompletionStatus ===
					PreworkCompletionStatus.COMPLETED
				}
			/>
		</>
	);
};
